import {useState} from "react";
import HotRank from "./rank/HotRank";
import NewRank from "./rank/NewRanks";
import DownRank from "./rank/DownRank";
import KeepScroll from "../../lib/KeepScroll";
import useActiveState from '../../lib/useActiveState';
import Manager from "../components/Manager";

const router = [
  {
    id: 'hotrank',
    component: HotRank,
    title: '热门榜',
  },
  {
    id: 'newrank',
    component: NewRank,
    title: '新游榜',
  },
  {
    id: 'downrank',
    component: DownRank,
    title: '下载榜',
  },
];

export default props => {
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [routerIndex, setRouterIndex] = useState(props.type || props.type === 0 ? props.type : 0);

  //排行榜tab埋点
  const clickTabOfTheRankList = (index) => {
    setRouterIndex(index);
    Manager.push({event_id:`C-2-${index+1}`})
  }

  return <div className="index-indexrank">
    <div className="indexrank-head width">
      {router.map((item, index) => <div key={index} className={'item ' + (index == routerIndex ? 'active' : '')} onClick={() => clickTabOfTheRankList(index)}>
        <div className="text">{item.title}</div>
        {/* <img src="/resources/index/bl.png" className="bl"/> */}
        <div className="line"></div>
      </div>)}
    </div>
    <div className="indexrank-body">
      {router.map((item, index) => <div key={index} className={'indexrank-body-item ' + (index == routerIndex ? 'active' : '')}>
        <KeepScroll active={props.active && index == routerIndex}>
          <item.component active={props.active && index == routerIndex}/>
        </KeepScroll>
      </div>)}
    </div>
  </div>;
};